import type { EventProperties } from '@/lib/analytics/events'

import { assertUnreachable } from '@/utils/type-utils'

import { ActivityTimelineItem } from '@/pages/control/risk-questionnaire-thread-card/activity-timeline-item'
import { CommentRowSkeleton } from '@/pages/control/risk-questionnaire-thread-card/comment-row-skeleton'
import { EvaluationGroup } from '@/pages/control/risk-questionnaire-thread-card/evaluation-group'
import type {
  StatusChange,
  ThreadTimelineEntry,
} from '@/pages/control/risk-questionnaire-thread-card/types'

import { CommentThread } from '@/components/shared/comment/comment-thread'

type RiskQuestionnaireTimelineItemProps = {
  entry: ThreadTimelineEntry
  lastAnalysisResultId?: string
  statusChanges: Map<string, StatusChange>
  readOnly: boolean
  trackingProps: EventProperties
}

export const RiskQuestionnaireTimelineItem = ({
  entry,
  lastAnalysisResultId,
  statusChanges,
  readOnly,
  trackingProps,
}: RiskQuestionnaireTimelineItemProps) => {
  switch (entry.kind) {
    case 'evaluations': {
      const [newest] = entry.evaluations
      return (
        <EvaluationGroup
          evaluations={entry.evaluations}
          isHighlighted={newest.id === lastAnalysisResultId}
          statusChanges={statusChanges}
          readOnly={readOnly}
          trackingProps={trackingProps}
        />
      )
    }
    case 'activity':
      return <ActivityTimelineItem activity={entry.activity} />
    case 'commentSlot':
      if (!entry.thread) return <CommentRowSkeleton />
      return (
        <CommentThread
          comments={entry.thread.comments}
          readOnly={readOnly}
          trackingProps={trackingProps}
        />
      )
    case 'liveThread':
      return (
        <CommentThread
          comments={entry.thread.comments}
          readOnly={readOnly}
          trackingProps={trackingProps}
        />
      )
    default:
      return assertUnreachable(entry)
  }
}
